import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class PaginationComponent implements OnChanges {
  // Inputs from parent
  @Input() currentPage = Number(1);
  @Input() totalPages = Number(1);
  @Input() pageSize = Number(10);
  @Input() totalItems = Number(0);
  @Input() showTotalEntries = Boolean(false);
  @Input() backgroundColor = String('bg-light-orange');
  @Input() removePadding = false;
  // Outputs to parent
  @Output() pageChange = new EventEmitter<number>();
  @Output() previousPage = new EventEmitter<void>();
  @Output() nextPage = new EventEmitter<void>();

  // Internal state
  pagesArray: number[] = [];
  displaySize = Number(0);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentPage'] || changes['totalPages']) {
      this.generatePagesArray();
    }
    if (changes['pageSize'] || changes['totalItems'] || changes['currentPage']) {
      this.calculateDisplaySize();
    }
  }

  generatePagesArray(): void {
    this.pagesArray = [];
    
    const start = Math.max(1, this.currentPage - 1);
    const end   = Math.min(this.totalPages, this.currentPage + 1);

    for (let i = start; i <= end; i++) {
      this.pagesArray.push(i);
    }
  }

  calculateDisplaySize(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.totalItems);
    this.displaySize = endIndex - startIndex;
  }

  onSetPage(page: number): void {
    if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  onPrevious(): void {
    if (this.currentPage > 1) {
      this.previousPage.emit();
    }
  }

  onNext(): void {
    if (this.currentPage < this.totalPages) {
      this.nextPage.emit();
    }
  }
}
